import { useCallback, useEffect, useState } from "react";
import { PopService } from "../services/PopService";

export const useHookPop = () => {
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [params, setParams] = useState({
    keyword: null,
    order_by: null,
    sort: null,
    page: 1,
  });

  const getData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await PopService.get({ params:params});
      setData(res.data.data);  
      setMeta(res.data.meta);  
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => {
    getData();
  }, [getData]);

  return {
    data,
    meta,
    loading,
    error,

    params,
    setParams,
    refreshData: () => getData(),
  };
};
